import React from "react";
import PropTypes from "prop-types";
import styled from "@emotion/styled";
import { useIntl } from "react-intl";
import { connect } from "react-redux";
import Placeholder from "components/Placeholder";
import ParkkiTheme from "themes/ParkkiTheme";
import Abilities from "services/permissions/abilities";
import IndicatorsActioner from "services/indicators/actioner";
import Section from "components/Section";
import IndicatorsTable from "scenes/Indicators/components/IndicatorsTable";
import Filters from "scenes/Indicators/components/Filters";

const Container = styled.div`
  display: flex;
  flex: 1;
  background-color: ${ParkkiTheme.colors.lightGrey};
  flex-direction: column;
`;

const FiltersContainer = styled.div`
  position: relative;
  display: flex;
  flex: 1;
  flex-direction: row;
`;

const MoreStatsButton = styled.div`
  color: ${ParkkiTheme.colors.turquoise};
  display: flex;
  flex-direction: row;
  cursor: pointer;
  padding: ${ParkkiTheme.spacings.tiny};
  align-self: flex-end;
  font-size: ${ParkkiTheme.fontSizes.small};
`;

const ArrowContainer = styled.label`
  justify-self: center;
  align-self: center;
  font-size: ${ParkkiTheme.fontSizes.xxsmall};
  font-family: Arial, Helvetica, sans-serif;
  margin-left: ${(props) =>
    props.fullScreen ? "0px" : ParkkiTheme.spacings.xsmall};
  margin-right: ${(props) =>
    props.fullScreen ? ParkkiTheme.spacings.xsmall : "0px"};
  padding-top: 2px;
`;

const IndicatorsLayout = ({
  retrieveIndicators,
  setFilter,
  tableFullScreen,
  onChangeTableFullScreen,
  indicators,
  filters,
  selectedColumn,
  setSelectedColumn,
  selectedIndicators,
  setSelectedIndicators,
  hoveredIndicator,
  setHoveredIndicator,
  leafletMap,
  loading,
  categories,
}) => {
  const intl = useIntl();

  return (
    <Container>
      <FiltersContainer>
        <Filters
          filters={filters}
          setFilter={setFilter}
          onSearch={retrieveIndicators}
          selectedIndicators={selectedIndicators}
          categories={categories}
        />
      </FiltersContainer>
      <Section title={intl.messages["indicatorsScene.title"]}>
        {Abilities.ability.can("read", "indicators.map") ? (
          <MoreStatsButton onClick={onChangeTableFullScreen}>
            {tableFullScreen ? (
              <ArrowContainer fullScreen={tableFullScreen}>◄</ArrowContainer>
            ) : null}
            {!tableFullScreen
              ? intl.messages["indicatorsScene.hideMap"]
              : intl.messages["indicatorsScene.showMap"]}
            {!tableFullScreen ? (
              <ArrowContainer fullScreen={tableFullScreen}>►</ArrowContainer>
            ) : null}
          </MoreStatsButton>
        ) : null}
      </Section>
      {loading ? (
        <Container style={{ padding: "0 26px" }}>
          <Placeholder delay={500} height="500px" />
        </Container>
      ) : (
        <IndicatorsTable
          indicators={indicators}
          categories={categories}
          selectedColumn={selectedColumn}
          setSelectedColumn={setSelectedColumn}
          selectedIndicators={selectedIndicators}
          setSelectedIndicators={setSelectedIndicators}
          hoveredIndicator={hoveredIndicator}
          setHoveredIndicator={setHoveredIndicator}
          leafletMap={leafletMap}
        />
      )}
    </Container>
  );
};

const mapStateToProps = (state) => ({
  filters: state.Indicators.filters,
  duration: state.GlobalFilters.duration,
  loading: !state.Indicators.initialized,
});

const mapDispatchToProps = (dispatch) => ({
  setFilter: (key, value) => dispatch(IndicatorsActioner.setFilter(key, value)),
});

IndicatorsLayout.defaultProps = {};

IndicatorsLayout.propTypes = {
  addFilter: PropTypes.func,
  removeFilter: PropTypes.func,
  filters: PropTypes.shape({}).isRequired,
  setFilter: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(IndicatorsLayout);
